export enum MonthNames {
  Januari = 1,
  Februari = 2,
  Maart = 3,
  April = 4,
  Mei = 5,
  Juni = 6,
  Juli = 7,
  Augustus = 8,
  September = 9,
  Oktober = 10,
  November = 11,
  December = 12,
}
